export default "__VITE_ASSET__Da9Yq8uY__"